import { useState } from 'react';
import { useNotifications } from '@/features/notifications/notifications.queries';
import { NotificationDropdown } from '@/components/notifications/NotificationDropdown';
import { useWebSocketNotifications } from '@/hooks/useWebSocketNotifications';

export function NotificationBell() {
  const [isOpen, setIsOpen] = useState(false);
  const { data } = useNotifications();
  useWebSocketNotifications(); // keeps the badge live without polling

  const unreadCount = data?.filter((n) => !n.isRead).length ?? 0;

  return (
    <div className="notification-bell">
      <button onClick={() => setIsOpen((o) => !o)} aria-label={`Notifications (${unreadCount} unread)`}>
        <i className="ti ti-bell" aria-hidden="true" />
        {unreadCount > 0 && <span className="notification-bell__badge">{unreadCount}</span>}
      </button>
      {isOpen && <NotificationDropdown onClose={() => setIsOpen(false)} />}
    </div>
  );
}
